import {useEffect, useImperativeHandle, useRef} from 'react';

export const useAutoResizeTextarea = (
  ref: React.ForwardedRef<HTMLTextAreaElement>,
  autoResize: boolean,
  value?: string | number | readonly string[],
) => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  useImperativeHandle(ref, () => textAreaRef.current!);

  useEffect(() => {
    const ref = textAreaRef?.current;

    const updateTextareaHeight = () => {
      if (ref && autoResize) {
        ref.style.height = 'auto';
        ref.style.height = ref?.scrollHeight + 'px';
      }
    };

    updateTextareaHeight();

    ref?.addEventListener('input', updateTextareaHeight);
    ref?.addEventListener('focus', updateTextareaHeight);

    return () => {
      ref?.removeEventListener('input', updateTextareaHeight);
      ref?.removeEventListener('focus', updateTextareaHeight);
    };
  }, [autoResize, value]);

  return {textAreaRef};
};
